<template lang="html">
  <button :class="[customClass, buttonClasses[styleType]]"><slot>Click</slot></button>
</template>

<script>
export default {
  data () {
    return {
      buttonClass: 'btn',
      buttonClasses: {
        primary: 'btn btn-primary btn-block',
        simple: 'btn btn-primary btn-block blue-button-simple',
        action: 'blueBtn mr-2'
      }
    }
  },
  props: {
    styleType: { type: String, default: 'primary' },
    customClass: { type: String }
  }
}
</script>

<style lang="scss">
</style>
